import { render } from "./MenuProduit.vue?vue&type=template&id=eddda608&ts=true"
import script from "./MenuProduit.vue?vue&type=script&lang=ts"
export * from "./MenuProduit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__